import { render } from "./EnrollmentCharge.vue?vue&type=template&id=aa456fea&ts=true"
import script from "./EnrollmentCharge.vue?vue&type=script&lang=ts"
export * from "./EnrollmentCharge.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__